"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _accessibility = require("../util/accessibility");

var TooltipBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(TooltipBody, _React$Component);

  function TooltipBody() {
    (0, _classCallCheck2["default"])(this, TooltipBody);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(TooltipBody).apply(this, arguments));
  }

  (0, _createClass2["default"])(TooltipBody, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (typeof this.props.updatedFn === 'function') {
        this.props.updatedFn();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var classes = (0, _classnames["default"])('zsg-tooltip', (0, _defineProperty2["default"])({
        'zsg-tooltip_open': this.props.open,
        'zsg-tooltip_animating': this.props.animating,
        // Animation transitions enabled
        'zsg-tooltip_opening': this.props.shown,
        // Transform/opacity transition
        'zsg-tooltip_closing': !this.props.shown && this.props.open
      }, 'zsg-tooltip_align-' + this.props.placement, this.props.animating));
      var style = {
        transformOrigin: this.props.transform,
        WebkitTransformOrigin: this.props.transform,
        MsTransformOrigin: this.props.transform,
        top: this.props.top,
        left: this.props.left
      };
      var arrowStyle = {
        top: this.props.arrowTop,
        left: this.props.arrowLeft
      };
      return _react["default"].createElement("div", {
        className: classes,
        style: style
      }, _react["default"].createElement("div", {
        className: "zsg-tooltip-content"
      }, _react["default"].createElement("a", {
        className: "zsg-icon-x-thick zsg-tooltip-close-no-handler",
        onClick: this.props.onClose,
        onKeyDown: function onKeyDown(e) {
          if ((0, _accessibility.shouldTriggerButton)(e.keyCode)) {
            // Prevent space bar from scrolling the page
            e.preventDefault();

            _this.props.onClose();
          }
        },
        tabIndex: "0",
        role: "button"
      }), _react["default"].createElement("span", {
        className: "zsg-tooltip-arrow",
        style: arrowStyle
      }), this.props.children));
    }
  }]);
  return TooltipBody;
}(_react["default"].Component);

exports["default"] = TooltipBody;
TooltipBody.propTypes = process.env.NODE_ENV !== "production" ? {
  animating: _propTypes["default"].bool,
  arrowLeft: _propTypes["default"].string,
  arrowTop: _propTypes["default"].string,
  children: _propTypes["default"].any,
  left: _propTypes["default"].string,
  onClose: _propTypes["default"].func.isRequired,
  open: _propTypes["default"].bool,
  placement: _propTypes["default"].oneOf(['right', 'left', 'top', 'bottom']),
  shown: _propTypes["default"].bool,
  top: _propTypes["default"].string,
  transform: _propTypes["default"].string,
  updatedFn: _propTypes["default"].func
} : {};
TooltipBody.defaultProps = {
  placement: 'right',
  open: true,
  shown: false,
  animating: false,
  top: '-10px',
  left: '30px',
  transform: 'left 20px 0px',
  arrow: {
    top: null,
    left: null
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Tooltip/TooltipBody.js
// module id = 501
// module chunks = 0